export default __webpack_public_path__ + "static/subset-UniNeueBold-Italic-5bffecdde3f9df3095e05ab4d9bb0839.woff2";